import c from "classnames";
import { ComponentProps, useMemo } from "react";

import classes from "./Input.module.css";

type Props = Omit<ComponentProps<"input">, "className"> & {
  transparent?: boolean;
  isPasswordManagerEnabled?: boolean;
};

export const Input = ({
  transparent,
  isPasswordManagerEnabled = false,
  ...rest
}: Props) => {
  // This controls if password managers should suggest values for this input
  const passwordManagerValues = useMemo(() => {
    return isPasswordManagerEnabled
      ? {}
      : {
          autoComplete: "off",
          "data-1p-ignore": "true",
          "data-lpignore": "true",
          "data-protonpass-ignore": "true",
        };
  }, [isPasswordManagerEnabled]);

  return (
    <input
      className={c(classes.input, transparent && classes.transparent)}
      {...passwordManagerValues}
      {...rest}
    />
  );
};
